import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductionPlanningComponent } from './production-planning/production-planning.component';
import { ReportsRoutingModule } from './reports-routing.module';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PurchasePlanningComponent } from './purchase-planning/purchase-planning.component';
import { ConsolidatedStockTransactionsComponent } from './consolidated-stock-transactions/consolidated-stock-transactions.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TransactionHistoryComponent } from './transaction-history/transaction-history.component';
import { StockBreakdownComponent } from './stock-breakdown/stock-breakdown.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MaterialAvailabilityCheckComponent } from './material-availability-check/material-availability-check.component';
import { PurchaseHistoryComponent } from './purchase-history/purchase-history.component';
import { SupplierComparisonComponent } from './supplier-comparison/supplier-comparison.component';
import { MaterialUsageTrendComponent } from './material-usage-trend/material-usage-trend.component';
import { ConsumptionAnalysisComponent } from './consumption-analysis/consumption-analysis.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ItemTransactionLogComponent } from './item-transaction-log/item-transaction-log.component';
import { PipeModuleModule } from 'src/app/pipe/pipe-module/pipe-module.module';
import { RptInvMtlAvailabilityComponent } from './rpt-inv-mtl-availability/rpt-inv-mtl-availability.component';
import { RptPrdProdnOutputComponent } from './rpt-prd-prodn-output/rpt-prd-prodn-output.component';
import { RptPrdConsumptionAnalysisComponent } from './rpt-prd-consumption-analysis/rpt-prd-consumption-analysis.component';
import { RptPrdRejectionAnalysisComponent } from './rpt-prd-rejection-analysis/rpt-prd-rejection-analysis.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { RptNonMovingItemsComponent } from './rpt-non-moving-items/rpt-non-moving-items.component';
import { StockAnalysisComponent } from './stock-analysis/stock-analysis.component';
import { BatchAnalysisComponent } from './batch-analysis/batch-analysis.component';
import { RptInvMultiMtlRequirementComponent } from './rpt-inv-multi-mtl-requirement/rpt-inv-multi-mtl-requirement.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations:
    [
      ProductionPlanningComponent,
      PurchasePlanningComponent,
      ConsolidatedStockTransactionsComponent,
      TransactionHistoryComponent,
      StockBreakdownComponent,
      MaterialAvailabilityCheckComponent,
      PurchaseHistoryComponent,
      SupplierComparisonComponent,
      MaterialUsageTrendComponent,
      ConsumptionAnalysisComponent,
      ItemTransactionLogComponent,
      RptInvMtlAvailabilityComponent,
      RptPrdProdnOutputComponent,
      RptPrdConsumptionAnalysisComponent,
      RptPrdRejectionAnalysisComponent,
      RptNonMovingItemsComponent,
      StockAnalysisComponent,
      BatchAnalysisComponent,
      RptInvMultiMtlRequirementComponent
    ],

  imports: [
    CommonModule,
    ReportsRoutingModule,
    MatTableModule,
    MatPaginatorModule,
    MatDatepickerModule,
    MatRadioModule,
    MatCheckboxModule,
    MatIconModule,
    MatSortModule,
    MatTableModule,
    FormsModule,
    PipeModuleModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
  ]
})
export class ReportsModule { }
